module.exports = __webpack_public_path__ + "static/media/bags.331b902d.jpg";